import { constants } from './constants';
import PptxGenJS from 'pptxgenjs';
import { convertHtmlToMarkdown } from './htmlToMarkdown/converter';
import { addLogoSlide } from '../pptxExport/addLogoSlide';
import { createPPTXSlide } from '../pptxExport/createPPTXSlide';
import startLogoPath from './assets/pptStartSlide.png';
import endLogoPath from './assets/pptEndSlide.png';

export const exportMessagesToPPTX = async (htmlContents: string[]) => {
  const pptx = new PptxGenJS();
  const markdownContents = convertHtmlToMarkdown(htmlContents);

  console.log("markdownContents", markdownContents);
  addLogoSlide(pptx, constants.SLIDE_DIMENSIONS, startLogoPath);

  for (const markdownContent of markdownContents) {
    await createPPTXSlide(pptx, markdownContent, constants.SLIDE_DIMENSIONS);
  }

  addLogoSlide(pptx, constants.SLIDE_DIMENSIONS, endLogoPath);
  await pptx.writeFile({ fileName: constants.FILE_NAME });
};
